type PlansCategoryRangeTrailingProps = {
  label: string
  showIdealRangeLabel?: boolean
}

export function PlansCategoryRangeTrailing({
  label,
  showIdealRangeLabel = true
}: PlansCategoryRangeTrailingProps) {
  if (label.length <= 0) {
    return null
  }

  return (
    <div className="flex items-center gap-1.5 text-[13px] font-[500] leading-none text-[#3D3D3D]">
      <IdealAllocationPieIcon />
      <span className="pt-px">
        {label}
        {showIdealRangeLabel ? <span className="font-[400]"> ideal range</span> : null}
      </span>
    </div>
  )
}

type IdealAllocationPieIconProps = {
  size?: number
}

export function IdealAllocationPieIcon({ size = 12 }: IdealAllocationPieIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className="shrink-0"
      aria-hidden
    >
      <path
        d="M11 1.83334V11L17.48 17.48C15.8268 19.1332 13.5848 20.062 11.2469 20.062C8.90898 20.062 6.66703 19.1332 5.01382 17.48C3.3606 15.8268 2.43184 13.5848 2.43184 11.2469C2.43184 8.90901 3.3606 6.66706 5.01382 5.01385C6.66703 3.36064 8.90902 2.43187 11.2469 2.43187L11 1.83334ZM12.8333 0.916672C15.4101 1.16093 17.804 2.36836 19.5481 4.3065C21.2921 6.24464 22.2615 8.75421 22.2714 11.3572H12.8333V0.916672Z"
        fill="#3D3D3D"
      />
    </svg>
  )
}
